import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		Pujcovna: [],
		Stanoviste: [],
		DphSazba: [],
		VozidloDruh: [],
		KaroserieTyp: [],
		PrevodovkaTyp: [],
		VpaVaria: [],
		Pouzitel: [],
		Palivo: [],
	},
	filter: {
		PujcovnaId: null as number | null,
		VozidloId: null as number | null,
		VozidloIdText: null as string | null,
		UzivatelvozId: null as number | null,
		UzivatelvozIdText: null as string | null,
		UzivatelvozOsobniCis: null as string | null,
		TechnikvozId: null as number | null,
		TechnikvozIdText: null as string | null,
		TechnikvozOsobniCis: null as string | null,
		Stanovst: null as string | null,
		KmStavOd: null as number | null,
		KmStavDo: null as number | null,
		PrioritaOd: null as number | null,
		PrioritaDo: null as number | null,
		PcOd: null as number | null,
		PcDo: null as number | null,
		DphSzbOzn: null as number | null,
		PalivoPzn: null as number | null,
		VozidlodruhPzn: null as number | null,
		KarostypPzn: null as number | null,
		PrevodtypPzn: null as number | null,
		Oznaceni: null as string | null,
		PouzitelList: null as number[] | null,
		VpaVariaList: null as number[] | null,
		VstupPracId: null as number | null,
		VstupPracIdText: null as string | null,
		VstupPracOsobniCis: null as string | null,
		VstupDatOd: null as string | null,
		VstupDatDo: null as string | null,
		// checkboxy
		PujcenePrp: null as boolean | null,
		PreslimitPrp: null as boolean | null,
		VyrazenePrp: null as boolean | null,
		Externivoz: null as boolean | null,
		Vlastnivoz: null as boolean | null,
	},
	tableSetting: {},
	localState: {
		VozidloRzv: null as string | null,
		VozidloVin: null as string | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.VOZIDLA_PUJCOVNY_VOZIDLO_SELECT_MAPPER](state, { data }) {
			state.filter.VozidloId = data.value;
			state.filter.VozidloIdText = data.text;
			state.localState.VozidloRzv = data.spz;
			state.localState.VozidloVin = data.karoserieNr;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_PRAC_UZIVATEL_SELECT_MAPPER](state, { data }) {
			state.filter.UzivatelvozId = data.value;
			state.filter.UzivatelvozIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.UzivatelvozOsobniCis = data.osobniCis;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_PRAC_TECHNIK_SELECT_MAPPER](state, { data }) {
			state.filter.TechnikvozId = data.value;
			state.filter.TechnikvozIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.TechnikvozOsobniCis = data.osobniCis;
		},
		[types.mutations.VOZIDLA_PUJCOVNY_VSTUP_PRAC_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
